"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditViewField = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const image_button_1 = require("../../components/button/image.button");
const modal_service_1 = require("../../components/modal/modal.service");
const icons_1 = require("../../components/icon/icons");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const spinner_1 = require("../../components/spinner/spinner");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const topological_editor_collection_edit_ctrl_1 = require("../../page/topological.editor.page/topological.editor.collection.edit.ctrl");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const collection_edit_model_1 = require("../../store/collection.edit.model");
const classnames_1 = require("../../util/classnames");
const collection_view_style_1 = require("./collection.view.style");
const field_view_builder_1 = require("./fields/field.view.builder");
class CollectionEditViewField {
    static view(ctrl, collection, schema) {
        const id = `i-${collection.instanceId}-${schema.id}`;
        const field = collection.getField(schema.id);
        const fieldView = field_view_builder_1.CollectionFieldViewBuilder.getFieldView(field);
        const hasValue = field.hasValue();
        const hasDetail = hasValue && fieldView.hasDetail && fieldView.hasDetail(field);
        const showDetail = ctrl.isFieldDetailShown.get(id);
        const hasUpload = fieldView.canUpload && fieldView.canUpload(field) && ctrl.isEditing;
        let imageTool = null;
        if (fieldView.canUpload && fieldView.canUpload(field)) {
            imageTool = field;
        }
        const hasGeocoding = fieldView.canGeocoding && fieldView.canGeocoding(field);
        const hasFile = fieldView.hasFile && fieldView.hasFile(field);
        let fileToolField = null;
        if (hasFile) {
            fileToolField = field;
        }
        const isLoading = (core_shared_1.CollectionModelFieldFileTool.isFileToolField(field) || core_shared_1.CollectionModelFieldImage.isImageField(field)) &&
            ctrl.isUploading &&
            ctrl.fieldsInLoadingState.indexOf(field.id) > -1;
        let hasClear = false;
        let fieldValue;
        const userIsAdmin = services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)) ||
            services_1.Services.UserProfile.isDepartmentDataAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId));
        const userCanEditField = userIsAdmin || !field.schema.adminOnly;
        if (ctrl.isEditing && userCanEditField) {
            fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value }, fieldView.viewEdit(field, ctrl));
            hasClear = fieldView.hasClear == null ? hasValue : fieldView.hasClear(field);
            // if the field is CollectionModelFieldVector and the provider is collection, but it's not exists anymore
            // the field text is 'Unknown' but we don't have value, so we don't show the clearButton
            // we fix that here
            if ((core_shared_1.CollectionModelFieldVector.isVectorField(field) || core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) &&
                typeof fieldView.viewEdit(field, ctrl) !== 'string' &&
                fieldView.viewEdit(field, ctrl).text === (0, i18n_1.Translate)(i18n_1.T.UNKNOWN)) {
                hasClear = true;
            }
        }
        else if (hasValue) {
            const inlineText = fieldView.viewInline(field, ctrl);
            if (typeof inlineText === 'string') {
                const children = [inlineText];
                if (
                // We have the correct token
                services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) &&
                    // And the field is one of the two list types which can have colors
                    (core_shared_1.CollectionModelFieldSelectList.isSelectListField(field) ||
                        core_shared_1.CollectionModelFieldNestedList.isNestedListField(field)) &&
                    // And this instance is the one that is marked as the color field
                    field.collection.schema.metadata.mapColorFieldId === field.schema.id) {
                    if (field.color) {
                        children.push((0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.colorIndicator, style: { backgroundColor: field.color } }));
                    }
                }
                fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value, title: inlineText }, children);
            }
            else {
                fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value }, inlineText);
            }
        }
        let showTrueSizeBadge = false;
        if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
            const rootFields = collection.schema.fields;
            let firstTrueSizeId = null;
            let anyTrueSizeHasCaptures = false;
            for (const schemaField of rootFields) {
                if (core_shared_1.FormModelFieldSubForm.isSubForm(schemaField))
                    continue;
                const f = collection.getField(schemaField.id);
                if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(f)) {
                    if (firstTrueSizeId == null) {
                        firstTrueSizeId = f.id;
                    }
                    if (f.getCaptures().length > 0) {
                        anyTrueSizeHasCaptures = true;
                        break;
                    }
                }
            }
            showTrueSizeBadge = firstTrueSizeId === field.id && !anyTrueSizeHasCaptures;
        }
        const title = schema.displayName;
        return (0, mithril_1.m)('div', {
            className: (0, classnames_1.classNames)(collection_view_style_1.CSS.field.container, {
                [collection_view_style_1.CSS.isEmpty]: !hasValue,
            }),
            id,
            onclick: (e) => {
                const handleClickAway = () => {
                    page_state_1.CurrentState.setInspectedFieldId(null);
                    services_1.Services.FocusAway.drop(e.target, handleClickAway);
                };
                page_state_1.CurrentState.setInspectedFieldId(field.id);
                services_1.Services.FocusAway.from(e.target, handleClickAway);
            },
        }, [
            (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.summary }, [
                (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.title, title }, title),
                fieldValue,
                showTrueSizeBadge ? (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.badge }) : null,
                isLoading ? CollectionEditViewField.viewLoadingSpinner(ctrl, field) : null,
                hasUpload ? CollectionEditViewField.viewFieldUploadButton(ctrl, imageTool) : null,
                hasFile ? CollectionEditViewField.viewFileDownloadButton(ctrl, fileToolField) : null,
                hasClear && hasFile ? CollectionEditViewField.viewFieldClearModalButton(ctrl, field) : null,
                hasClear && !hasFile ? CollectionEditViewField.viewFieldClearButton(ctrl, field, collection) : null,
                hasDetail ? CollectionEditViewField.viewFieldDetailButton(ctrl, id) : null,
                hasGeocoding ? CollectionEditViewField.viewFieldGeocodingButton(ctrl, field) : null,
                hasGeocoding && !ctrl.clearErrorDisabled(field)
                    ? CollectionEditViewField.viewFieldClearErrorButton(ctrl, field)
                    : null,
            ]),
            showDetail ? (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.detail }, fieldView.viewDetail(field)) : null,
        ]);
    }
    static viewFieldClearErrorButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: () => ctrl.clearError(field),
            disabled: ctrl.clearErrorDisabled(field),
        });
    }
    static viewFieldClearButton(ctrl, field, collection) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const handled = yield CollectionEditViewField.handleSpanFieldClear(field, ctrl, collection.collection);
                if (!handled) {
                    ctrl.clearField(field);
                }
            }),
        });
    }
    /**
     * Handle clearing a span vector field with two-way link detection.
     * If the field is a span vector with a reciprocal link, shows a confirmation
     * dialog and clears both sides. Returns false for standard clear fallthrough.
     */
    static handleSpanFieldClear(field, ctrl, collection) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
                return false;
            }
            if (!collection || !field.isPartOfSpanSubForm() || !(0, core_shared_1.hasCompleteSpanTypeState)(field.parent.schema)) {
                return false;
            }
            if (!field.isCollectionLink()) {
                return false;
            }
            let reciprocal;
            try {
                reciprocal = yield services_1.Services.SubFormLink.findReciprocalLink(field, collection);
            }
            catch (_a) {
                return false;
            }
            if (!reciprocal) {
                return false;
            }
            const targetTitle = reciprocal.targetCollection.title || 'linked collection';
            const confirmed = yield modal_service_1.ModalService.open({
                title: i18n_1.T.SPAN_UNLINK_CONFIRM_TITLE,
                content: (0, i18n_1.Translate)(i18n_1.T.SPAN_UNLINK_CONFIRM_MESSAGE, { targetTitle }),
                hasCancel: true,
                okName: i18n_1.T.SPAN_UNLINK_CONFIRM_OK,
            });
            if (!confirmed.ok) {
                return true;
            }
            // Clear source vector field
            field.Mutator.clear();
            // Check if this is an unsaved two-way link that can be fully reverted.
            // Only do this on the map page — the topo editor manages each pole's edit
            // state independently, so the target may have other legitimate changes.
            const isMapPage = !topological_editor_collection_edit_ctrl_1.TopologicalEditorCollectionEditCtrl.is(ctrl);
            const removedLink = isMapPage
                ? page_state_1.CurrentState.CollectionLink.findAndRemovePendingTwoWayLink(reciprocal.targetCollection, reciprocal.targetSpanInstance)
                : null;
            if (removedLink) {
                if (reciprocal.targetCollection.isEditing) {
                    reciprocal.targetVectorField.Mutator.clear();
                }
            }
            else {
                // Previously saved link, or topo editor — clear target vector and track for save
                if (!reciprocal.targetCollection.isEditing) {
                    if (topological_editor_collection_edit_ctrl_1.TopologicalEditorCollectionEditCtrl.is(ctrl)) {
                        ctrl.registerCollectionForEditing(reciprocal.targetCollection);
                    }
                    else {
                        reciprocal.targetCollection.beginEdit((state) => new collection_edit_model_1.CollectionModelStateEdit(state));
                    }
                }
                reciprocal.targetVectorField.Mutator.clear();
                // Store pending unlink for save ordering
                page_state_1.CurrentState.CollectionLink.addPendingBidirectionalUnlink({
                    targetCollection: reciprocal.targetCollection,
                    targetSpanInstance: reciprocal.targetSpanInstance,
                    sourceCollectionId: collection.id,
                });
            }
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'span:unlink:two-way', field.schema.displayName, 1);
            notification_service_1.NotificationService.info({
                key: i18n_1.T.SPAN_UNLINK_BOTH_SIDES,
                attrs: { targetTitle },
            });
            return true;
        });
    }
    static viewFieldClearModalButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: () => ctrl.clearModalField(field),
        });
    }
    static viewFieldDetailButton(ctrl, fieldInstanceId) {
        let icon = icons_1.MaterialIcon.INFO_FILLED;
        if (ctrl.isFieldDetailShown.get(fieldInstanceId)) {
            icon = icons_1.MaterialIcon.INFO;
        }
        return image_button_1.ImageButton.view(icon, {
            onclick: () => ctrl.toggleFieldDetail(fieldInstanceId),
        });
    }
    static viewFieldGeocodingButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.LOCATION, {
            onclick: () => ctrl.fillAddress(field),
            disabled: ctrl.fillAddressDisabled(field),
            title: ctrl.geocodingButtonTitle(field),
        });
    }
    static viewLoadingSpinner(ctrl, field) {
        return spinner_1.Spinner.view();
    }
    static viewFileDownloadButton(ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
            onclick: (e) => ctrl.fileDownload(field),
        });
    }
    static viewFieldUploadButton(ctrl, field) {
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.isImageUpload }, (0, mithril_1.m)('form', [
            (0, mithril_1.m)('input', {
                className: 'c--Image--fileupload',
                style: 'display:none;',
                type: 'file',
                accept: 'image/jpeg',
                id: field.id,
                onchange: (e) => ctrl.onImage(e, field),
            }, ''),
            (0, mithril_1.m)('div', {
                id: `image-upload-${field.id}`,
                style: 'border:none',
                className: collection_view_style_1.CSS.container,
                onclick: (e) => ctrl.openImageDialog(e, field),
            }, image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_UPLOAD)),
        ]));
    }
}
exports.CollectionEditViewField = CollectionEditViewField;
//# sourceMappingURL=collection.view.field.js.map